import { CACHE_DONNEES } from '../sw/caches'

// Au-delà, Keycloak est tenu pour injoignable : réseau absent, ou trop faible pour s'y connecter
const DELAI_KEYCLOAK_MS = 4000
const CLE_PERSONNE = 'mamarotte.personne'

/**
 * Le réseau atteint-il Keycloak ? Sinon l'appli démarre hors ligne : la connexion redirigerait vers une page morte.
 * Keycloak accepte le CORS de toute origine ; no-store : le service worker ne la garde pas, la réponse vient du réseau.
 */
export async function keycloakJoignable(url: string): Promise<boolean> {
  if (!navigator.onLine) return false
  try {
    await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(DELAI_KEYCLOAK_MS) })
    return true
  } catch {
    return false
  }
}

/** Efface les lectures de l'API gardées pour le hors ligne. */
export async function oublierDonneesHorsLigne(): Promise<void> {
  await caches.delete(CACHE_DONNEES)
}

/** Une autre personne se connecte sur ce téléphone : rien des données gardées de la précédente ne lui reste. */
export async function retenirPersonne(id: string): Promise<void> {
  if (localStorage.getItem(CLE_PERSONNE) === id) return
  await oublierDonneesHorsLigne()
  localStorage.setItem(CLE_PERSONNE, id)
}
